import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { downloadSdsFile } from './api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<number>, 'enabled'>;

export default function useSdsDownloadFile(
  chemicalProductId: string,
  options?: UseQueryOptionsKeys
) {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery(
    ['downloadedSdsFile', chemicalProductId],
    () => downloadSdsFile(chemicalProductId),
    {
      onError: error => {
        toast.error(t('toast.title.error.download.sds.file'));
      },
      ...options,
    }
  );

  return { sdsFile: data, isLoading };
}
